"use client";

import { usePathname } from "next/navigation";

import { DEFAULT_LOCALE, getLocaleFromPathname } from "@/lib/i18n/locales";

import NavigationLink, { getNavigationLinks } from "./navigation-link";

export default function NavigationDesktop() {
  const pathname = usePathname();
  const locale = pathname ? getLocaleFromPathname(pathname) : DEFAULT_LOCALE;
  const navigationLinks = getNavigationLinks(locale);

  return (
    <ul className="hidden lg:flex items-center gap-5 xl:gap-8">
      {navigationLinks.map(navlink => (
        <NavigationLink key={navlink.title} {...navlink} />
      ))}
    </ul>
  );
}
